import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import EmergencyChart from "./EmergencyChart";

export const EmergencyCard = ({ data }) => {
  const transformData = (data) => {
    if (!data) return {};

    const weeks = Object.keys(data);
    const categories = ["Health", "Theft", "Fire", "Others"];
    const transformedData = {
      labels: weeks,
      datasets: categories.map((category) => ({
        label: category,
        data: weeks.map((week) => {
          const weekData = data[week].find((entry) => entry.type === category);
          return weekData ? weekData.count : 0;
        }),
        borderColor: getColorForCategory(category),
        fill: false,
        pointRadius: 5,
        pointBackgroundColor: getColorForCategory(category),
        pointBorderWidth: 2,
        tension: 0.4,
        cubicInterpolationMode: "monotone",
      })),
    };
    return transformedData;
  };

  const getColorForCategory = (category) => {
    switch (category) {
      case "Health":
        return "#072f64";
      case "Theft":
        return "purple";
      case "Fire":
        return "orange";
      case "Others":
        return "#5596e0";
      default:
        return "#000";
    }
  };

  const chartData = transformData(data);

  return (
    <Box
      bg={"#FFFFFF"}
      borderRadius="10px"
      boxShadow="0px 3px 6px #0000003B"
      p={"15px"}
      w={["100%", "100%", "48.5%"]}
    >
      <Flex
        justify={["center", "center", "space-between"]}
        direction={["column", "column", "row"]}
        w={"100%"}
        align={"center"}
        mb={"20px"}
        px={["10px", "10px", "5px"]}
      >
        <Box>
          <Heading fontSize={["16px", "18px"]} color={"#000"}>
            Emergency Chart
          </Heading>
        </Box>
        <Box fontWeight={400} w={["100%", "100%", "60%"]}>
          <Flex>
            {graphHead.map((data) => (
              <Flex align={"center"} pb={"0px"} key={data.head} 
              // flexWrap={"wrap"}
              >
                <Box
                  h="11px"
                  w="11px"
                  rounded={"sm"}
                  bg={data.color}
                  mr="10px"
                ></Box>
                <Text pr={"10px"} color={"#000"}>
                  {data.head}
                </Text>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Flex>
      {data ? <EmergencyChart data={chartData} /> : <Text>No Data Available...</Text>}
    </Box>
  );
};

export const graphHead = [
  {
    color: "#072f64",
    head: "Health",
  },
  {
    color: "purple",
    head: "Theft",
  },
  {
    color: "orange",
    head: "Fire",
  },
  {
    color: "#5596e0",
    head: "Others",
  },
];

export default EmergencyCard;

// import { Box, Flex, Heading, Text } from "@chakra-ui/react";
// import EmergencyChart from "./EmergencyChart";

// export const EmergencyCard = ({data}) => {
//   console.log(data, "dataa")
//   return (
//     <Box
//       bg={"#FFFFFF"}
//       borderRadius="10px"
//       boxShadow="0px 3px 6px #0000003B"
//       p={"15px"}
//       w={["100%", "100%", "48.5%"]}
//       // flex={1}
//     >
//       <Flex
//         justify={["center", "center", "space-between"]}
//         direction={["column", "column", "row"]}
//         w={"100%"}
//         align={"center"}
//         mb={"20px"}
//         px={["10px", "10px", "5px"]}
//       >
//         <Box>
//           <Heading fontSize={["16px", "18px"]} color={"#000"}>
//             Emergency Chart
//           </Heading>
//         </Box>
//         <Box fontWeight={400} w={["100%", "100%", "55%"]}>
//           <Flex>
//             {graphHead.map((data) => (
//               <Flex align={"center"} pb={"0px"}>
//                 <Box
//                   h="11px"
//                   w="11px"
//                   rounded={"sm"}
//                   bg={data.color}
//                   mr="10px"
//                 ></Box>
//                 <Text pr={"10px"} color={"#000"}>{data.head}</Text>
//               </Flex>
//             ))}
//           </Flex>
//         </Box>
//       </Flex>
//       <EmergencyChart data={data} />
//     </Box>
//   );
// };

// export const graphHead = [
//   {
//     color: "#072f64",
//     head: "Health",
//   },
//   {
//     color: "purple",
//     head: "Theft",
//   },
//   {
//     color: "orange",
//     head: "Fire",
//   },
//   {
//     color: "blue.100",
//     head: "Others",
//   },
// ];
